import React, { useRef, useCallback } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./quill-custom.css";
import CustomFormLabel from "../forms/theme-elements/CustomFormLabel";
import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";
import { ChackImageIsFile } from "src/helper/publicFunction";
// import { uploadImage } from "../../services/api"; // You'll need to create this service

const EditorComponent = ({ data, title, onChange, disabled = false, key }) => {
  const editorRef = useRef(null);
  const quillRef = useRef(null);

  const handleEditorChange = (content, delta, source, editor) => {
    onChange(content);
  };

  const UploadFileMessage = async ({ callback, file }) => {
    try {
      var bodyFormData = new FormData();
      if (
        file &&
        file != null &&
        file != undefined &&
        ChackImageIsFile({ data: file, IsBoolean: true })
      ) {
        bodyFormData.append("file", file);
      } else if (!file) {
        bodyFormData.append("file", "");
      }
      const response = await PostFunction({
        data: bodyFormData,
        Route: UrlApi.chat.upload,
        showalert: false,
        state: null,
        isMultipart: true,
        dispatch: null,
        is_client: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

  const imageHandler = useCallback(() => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      if (!file) return;

      try {
        // Here you would typically upload the file to your server
        // and get back the image URL
        const formData = new FormData();
        formData.append("image", file);

        // Replace with your actual upload endpoint
        await UploadFileMessage({
          callback: (data) => {
            // Insert the image into the editor
            const quill = quillRef.current.getEditor();
            const range = quill.getSelection(true);
            quill.editor.insertEmbed(
              range.index,
              "image",
              UrlApi.baseUrlImage + data?.data
            );
            quill.setSelection(range.index + 1);
            handleEditorChange(quill.root.innerHTML);
          },
          file,
        });
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    };
  }, []);

  const modules = {
    toolbar: {
      container: [
        [{ size: [] }],
        [
          { header: "1" },
          { header: "2" },
          { header: [3, 4, 5, 6] },
          { color: [] },
          { background: [] },
        ],
        ["bold", "italic", "underline", "strike", "blockquote", "code-block"],
        [{ script: "sub" }, { script: "super" }],
        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
        ],
        [{ direction: "rtl" }],
        [{ align: [] }],
        ["link", "image", "video"],
        ["clean"],
      ],
      handlers: {
        image: imageHandler,
      },
    },
  };

  const formats = [
    "header",
    "font",
    "size",
    "color",
    "background",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "code-block",
    "script",
    "list",
    "bullet",
    "indent",
    "direction",
    "align",
    "link",
  ];

  return (
    <div key={key}>
      <div style={{ marginBottom: "20px" }} />
      <CustomFormLabel>{title}</CustomFormLabel>
      <ReactQuill
        ref={quillRef}
        value={data}
        onChange={handleEditorChange}
        readOnly={disabled}
        modules={modules}
        formats={[...formats, "image", "video"]}
        style={{ height: "400px", margin: 0, padding: 0 }}
      />
      <div style={{ marginBottom: "20px" }} />
    </div>
  );
};

export default EditorComponent;
